import { render, staticRenderFns } from "./MoblieHome.vue?vue&type=template&id=2edc5baa&scoped=true&"
import script from "./MoblieHome.vue?vue&type=script&lang=js&"
export * from "./MoblieHome.vue?vue&type=script&lang=js&"
import style0 from "./MoblieHome.vue?vue&type=style&index=0&id=2edc5baa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc5baa",
  null
  
)

export default component.exports